import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AgentDto, RolePermissionEnum } from '../../service/dto';
import { concatMap, finalize, merge, Subscription, tap } from 'rxjs';
import { HttpAgentService } from '../../service/http-agent.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../service/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { uniqueFieldValidator } from '../agent-provision/agent-provision.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgentEditComponent } from './components/agent-edit/agent-edit.component';
@Component({
	selector: 'app-agent-view',
	standalone: false,
	templateUrl: './agent-view.component.html',
	styleUrl: './agent-view.component.scss'
})
export class AgentViewComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	id!: number;
	agent!: AgentDto;
	selectedTabIndex = 0;
	selectedTab?: RolePermissionEnum;
	loading = false;

	constructor(
		private service: HttpAgentService,
		private authService: AuthService,
		private agentService: HttpAgentService,
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private fb: FormBuilder,
		private modalService: NgbModal) { }

	ngOnInit(): void {
		this.loading = true;
		this.subscription.add(
			this.activatedRoute.paramMap
				.pipe(
					tap(item => this.loading = true),
					concatMap(item => {
						if (item.get('agentId')) {
							return this.service.get(+item.get('agentId')!);
						}
						return this.service.getSelf();
					}),
					finalize(() => this.loading = false)
				)
				.subscribe(result => {
					console.log("AgentViewComponent.ngOnInit: result=", result);
					this.agent = result;
				}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get portraitImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.agent.portraitImage!.imageData);
	}
	get documentFrontImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.agent.documentFrontImage!.imageData);
	}
	get documentBackImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.agent.documentBackImage!.imageData);
	}


	get governmentPhotoImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.agent.governmentPhotoImage!.imageData);
	}
	get governmentPassportImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.agent.governmentPassportImage!.imageData);
	}

	setSelectedTab(index: number) {
		this.selectedTabIndex = index;
		if (index == 0 || index == 1) {
			this.selectedTab = 'AgentView';
			return;
		}
		const tabs: RolePermissionEnum[] = [];
		tabs.push('AgentView');
		tabs.push('AgentView');
		if (this.authService.hasPermission('AuditSessionList')) {
			tabs.push('AuditSessionList');
		}
		if (this.authService.hasPermission('AuditViewList')) {
			tabs.push('AuditViewList');
		}
		if (this.authService.hasPermission('AuditSearchList')) {
			tabs.push('AuditSearchList');
		}
		if (this.authService.hasPermission('AuditModificationList')) {
			tabs.push('AuditModificationList');
		}
		this.selectedTab = tabs[index];
	}
	isRender(section: RolePermissionEnum): boolean {//selectedTab: 'AgentView'|'AuditSession'|'AuditView'|'AuditSearch'|'AuditModification';)
		return section == this.selectedTab;
	}

	doBlock() {
		this.loading = false;
		this.service.block(this.agent).pipe(
			finalize(() => this.loading = false)
		)
			.subscribe(result => this.agent = result);
	}
	doUnblock() {
		this.loading = false;
		this.service.unblock(this.agent).pipe(
			finalize(() => this.loading = false)
		)
			.subscribe(result => this.agent = result);
	}
	doReset() {
		this.loading = false;
		this.service.reset(this.agent).pipe(
			finalize(() => this.loading = false)
		)
			.subscribe(result => this.agent = result);
	}
	get isSelf(): boolean {
		return this.agent.id == this.authService.authState?.agent.id;
	}
	doEdit(){
		const modalRef = this.modalService.open(AgentEditComponent, { size: 'lg' });
		modalRef.componentInstance.agent = this.agent;
		modalRef.result.then((result: AgentDto) => {
			if (result) {
				this.loading = true;
				const reloadAgent = this.isSelf
					? this.service.getSelf()
					: this.service.get(this.agent.id);
				this.subscription.add(
					reloadAgent
						.pipe(finalize(() => this.loading = false))
						.subscribe(agent => this.agent = agent)
				);
			}
		}, () => {});
	}

	getCardHeaderColor(){
		if(this.agent.status == 'Approved'){
			return 'text-bg-success';
		}
		if(this.agent.status == 'Blocked'){
			return 'text-bg-danger';
		}
		if(this.agent.status == 'Rejected'){
			return 'text-bg-danger';
		}
		if(this.agent.status == 'Suspended'){
			return 'text-bg-danger';
		}
		if(this.agent.status == 'BlockedOtp'){
			return 'text-bg-danger';
		}
		if(this.agent.status == 'PendingApproval'){
			return 'text-bg-warning';
		}
		if(this.agent.status == 'PendingRegistration'){
			return 'text-bg-warning';
		}
		return 'text-bg-secondary';
	}
	getCardBorderColor(){
		if(this.agent.status == 'Approved'){
			return 'border-success';
		}
		if(this.agent.status == 'Blocked'){
			return 'border-danger';
		}
		if(this.agent.status == 'Rejected'){
			return 'border-danger';
		}
		if(this.agent.status == 'Suspended'){
			return 'border-danger';
		}
		if(this.agent.status == 'BlockedOtp'){
			return 'border-danger';
		}
		if(this.agent.status == 'PendingApproval'){
			return 'border-warning';
		}
		if(this.agent.status == 'PendingRegistration'){
			return 'border-warning';
		}
		return 'border-secondary';
	}
}
